export default __webpack_public_path__ + "static/media/VideoCallMockupSmall.b236dcea.png";